import { INoticeData, FNavigateToCallback, TNavigateToType } from '@/sub-luca-plugin/types';
import { isWeApp, addEventCenterOfOnce, environment } from './index';

// 获取token方法，从外部设置， 获取
class HandleToken {
    getTokenFn?: () => Promise<string>;

    getHttpConfigFn?: () => Promise<{ baseURL: string; accessToken: string; headers: Record<string, string> }>;

    linkToLoginPage?: (data: any) => void;
    setGetTokenFn(cb: () => Promise<string>) {
        this.getTokenFn = cb;
    }

    setGetHttpConfigFn(cb: () => Promise<{ baseURL: string; accessToken: string; headers: Record<string, string> }>) {
        this.getHttpConfigFn = cb;
    }

    setLinkToLoginPage(cb: (data: any) => void) {
        this.linkToLoginPage = cb;
    }
    getFronttoken() {
        return this.getTokenFn ? this.getTokenFn() : Promise.resolve('');
    }

    async getHttpConfig() {
        if (this.getHttpConfigFn) {
            return this.getHttpConfigFn();
        } else {
            const accessToken = await this.getFronttoken();
            return {
                baseURL: environment.getApigateWay(),
                accessToken,
                headers: {},
            };
        }
    }
}

export const handleTokenExample = new HandleToken();

class QueryDomMethods {
    shadowRoot?: ShadowRoot;
    setShadowRoot = (root: ShadowRoot) => {
        this.shadowRoot = root;
    };
    querySelector = (name: string) => {
        if (isWeApp) return {} as any;
        return (this.shadowRoot ? this.shadowRoot.querySelector(name) : document.body.querySelector(name)) as any;
    };
    querySelectorAll = (name: string) => {
        if (isWeApp) return {} as any;
        return this.shadowRoot ? this.shadowRoot.querySelectorAll(name) : document.body.querySelectorAll(name);
    };
    queryLucaQaRoot = () => {
        if (isWeApp) return {} as any;
        return (this.shadowRoot ? this.shadowRoot.querySelector('#luca-qa-root')! : document.body.querySelector('#luca-qa-root')!) as any;
    };
}

export const queryDomExample = new QueryDomMethods();

type EventBusName =
    | 'main-app'
    | 'QaDrawer'
    | 'NavgationBar'
    | 'DialogueArea'
    | 'DialogueTool'
    | 'QaInitOverlay'
    | 'QaToast'
    | 'QaDetailToast'
    | 'WarningModal'
    | 'EvaluteModal'
    | 'FeedbackModal'
    | 'CombinePicturesDrawer'
    | 'SimilarSearchDrawer'
    | 'QaDetailDrawer'
    | 'KnowledgePointsDrawer'
    | 'PictureCrop'
    | 'PicturePreview'
    | 'VideoPlayerModal'
    | 'QaDetailRightDrawer'
    | 'KnowledgePointsRightDrawer'
    | 'EquityModal'
    | 'RechargRecordModal'
    | 'WeappEntryContainer';

class EventBus {
    callbacks: Record<string, (data: INoticeData) => void> = {};

    // 外部传入的回调集合
    externalCallbacks: Record<string, (data?: any) => any> = {};

    setExternalCallbacks = (callbacks: Record<string, (data?: any) => any>) => {
        this.externalCallbacks = callbacks;
    };

    subscribe = (key: EventBusName, callback: (data: INoticeData) => void) => {
        this.callbacks[key] = callback;
    };

    publish = (key: EventBusName, data: INoticeData) => {
        const callback = this.callbacks[key];
        if (callback) {
            callback(data);
        } else {
            console.log(`${key}-未注册该回调`);
        }
    };
}

export const eventBusExample = new EventBus();

// 接收外部传入的跳转方法
class Navigate {
    navigateTo?: FNavigateToCallback;
    setLinkTo(linkToFn: FNavigateToCallback) {
        this.navigateTo = linkToFn;
    }
    publish(type: TNavigateToType, data: Record<string, any> = {}, callbacks?: Record<string, (...args: any) => void>) {
        switch (type) {
            case 'qa':
                eventBusExample.publish('QaDrawer', { type: 'open', params: data, callbacks });
                break;
            case 'video':
                eventBusExample.publish('VideoPlayerModal', {
                    type: 'open',
                    params: data,
                    callbacks,
                });
                break;
            case 'equity':
                eventBusExample.publish('EquityModal', { type: 'open', params: data });
                break;
            case 'similar_search':
                eventBusExample.publish('SimilarSearchDrawer', { type: 'open', params: data });
                break;
            case 'knowledge_points_detail':
                eventBusExample.publish(data.from === 'my_collect' ? 'KnowledgePointsRightDrawer' : 'KnowledgePointsDrawer', {
                    type: 'open',
                    params: data,
                    callbacks,
                });
                break;
            case 'gbot_detail':
            case 'qa_pair_detail':
                eventBusExample.publish(data.from === 'my_collect' ? 'QaDetailRightDrawer' : 'QaDetailDrawer', {
                    type: 'open',
                    params: { type, ...data },
                    callbacks,
                });
                break;
            case 'problem_analysis':
                {
                    let url = `https://${environment.getApiEnv()}sub-tiku.gaodun.com/single/question/${data.questionId}?color=5262ff`;
                    if (data.littleQuestionId) url += `&sid=${data.littleQuestionId}`;
                    window.open(url);
                }
                break;
            case 'webview':
                window.open(data.url);
                break;
            default:
                break;
        }
    }
    linkTo: FNavigateToCallback = (type, data, callbacks) => {
        console.log('linkTo', type, data, callbacks);
        if (!this.navigateTo) {
            this.publish(type, data, callbacks);
            return;
        }
        const newData = { ...data };
        if (['gbot_detail', 'qa_pair_detail'].includes(type)) {
            newData.type = type;
        }
        this.navigateTo?.(type, newData);
        callbacks && addEventCenterOfOnce(callbacks);
    };
}

export const navigateExample = new Navigate();
